import React, { useState, useEffect } from 'react';
import { Col, Row, Card, Button, Input, Label } from 'reactstrap';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import CustomModal from '../../../../../../../Components/Modals/CustomModal';
import ViewIcon from '../../../../../../../../designUtils/ProjectDashboard/ViewIcon.svg';
import DownloadIcon from '../../../../../../../../designUtils/ProjectDashboard/DownloadIcon.svg';
import CommentIcon from '../../../../../../../../designUtils/ProjectDashboard/CommentIcon.svg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import LoadingOverlay from "react-loading-overlay";
import Loader from "react-loaders";
import SendAssetsApprovalPopup from './SendAssetsApprovalPopup';
import AddSubmissionsChatService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/AddSubmissionsChatService';
import FetchSubmissionsChatsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchSubmissionsChatsService';
import AssetsCommentsPopup from '../AssetAnnotations/AssetsCommentsPopup';
import ReactQuill from 'react-quill';
import { Editor } from '../../../../../../../../Utils/Constants';

function AllSubmission(props) {
  const [asinList, setAsinList] = useState();
  const [documentSearchText, setDocumentSearchText] = useState('');
  const [imageSearchText, setImageSearchText] = useState('');
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectAllImages, setSelectAllImages] = useState(false);
  const [isAttachmentOpen, setIsAttachmentOpen] = useState(false);
  const [filePath, setFilePath] = useState('');
  const [selectedFileObject, setSelectedFileObject] = useState({});
  const [downloading, setdownloading] = useState(false);
  const [isCommentsPopUpOPen, setIsCommentsPopUpOPen] = useState(false);
  const [loadScreen, setLoadScreen] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [selectAllDocuments, setSelectAllDocuments] = useState(false);
  const [comment, setComment] = useState('');
  const [noteList, setNoteList] = useState([]);
  const [demoImage, setDemoImage] = useState(false);
  const [confrimationForSubmition, setConfrimationForSubmition] = useState(false);
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [sumbmissionNote, setSubmissionNote] = useState('');

  // NEW: ASIN-based filtering states
  const [filteredImages, setFilteredImages] = useState([]);
  const [filteredDocuments, setFilteredDocuments] = useState([]);
  useEffect(() => {
    console.log(props.graphicsfileList)
    console.log(props.docFileList)
        const filteredImage = getFilteredImageFiles(props.graphicsfileList, props.selectedASIN);
        setFilteredImages(filteredImage);
        const filtered = getFilteredDocumentFiles(props.docFileList, props.selectedASIN);
      setFilteredDocuments(filtered);
      }, [props.selectedASIN, props.docFileList,props.graphicsfileList]);
 
      const getFilteredImageFiles = (graphicsfileList, selectedASIN) => {
        return (graphicsfileList || []).filter(file => {
          const isGraphics = file.actualFileName && file.assetSubCategory === 7; // Graphics=7
          if (!isGraphics) return false;
      
          // Parse ASINs (convert to uppercase for matching)
          const fileAsins = (typeof file.asinList === 'string' && file.asinList.trim() !== '')
            ? file.asinList.split(',').map(a => a.trim().toUpperCase()).filter(Boolean)
            : [];
      
          // Handle "OTHERS" (no ASINs linked)
          if (selectedASIN === "Unmapped Assets") {
            return fileAsins.length === 0;
          }
      
          // Normal ASIN match
          const normalizedSelectedASIN = selectedASIN ? selectedASIN.toUpperCase() : '';
          return fileAsins.includes(normalizedSelectedASIN);
        });
      };
      
      const getFilteredDocumentFiles = (fileList, selectedASIN) => {
        const documentExtensions = ['csv', 'docx', 'xlsx', 'xls', 'doc', 'xlsm', 'pdf'];
    
        return (fileList || []).filter(file => {
          const isDocument = file.actualFileName &&
            documentExtensions.includes(file.actualFileName.split('.').pop().toLowerCase());
    
          if (!isDocument) {
            return false;
          }
    
          const fileAsins = (typeof file.asinList === 'string' && file.asinList.trim() !== '')
            ? file.asinList.split(',').map(a => a.trim().toUpperCase()).filter(Boolean)
            : [];
    
          if (selectedASIN === "Unmapped Assets") {
            const isOthers = fileAsins.length === 0;
            return isOthers;
          }
    
          const normalizedSelectedASIN = selectedASIN ? selectedASIN.toUpperCase() : '';
          const isMatch = fileAsins.includes(normalizedSelectedASIN);
          return isMatch;
        });
      };
  

  // NEW: Apply search filter to already ASIN-filtered documents
  const searchedDocuments = filteredDocuments.filter(file =>
    file.actualFileName.toLowerCase().includes(documentSearchText.toLowerCase()) ||
    String(file.id).includes(documentSearchText)
  );

  // NEW: Apply search filter to already ASIN-filtered images
  const searchedImages = filteredImages.filter(file =>
    file.actualFileName.toLowerCase().includes(imageSearchText.toLowerCase()) ||
    String(file.id).includes(imageSearchText)
  );

  const submissionsChats = (file) => {
    console.log(file);
    let data = {
      assetId: file.id
    };
    setSelectedFileObject(file);
    setLoadScreen(true);
    FetchSubmissionsChatsService(props.token, data).then((res) => {
      console.log(res);
      setNoteList(res);
      setLoadScreen(false);
    });
    setIsCommentsPopUpOPen(true);
    showNote(file.fileName, file.filePath);
  };

  const showNote = (path, fullPath) => {
    console.log(path);
    const ext = path.split(".")[1];
    if (ext == "xlsx" || ext == "csv" || ext == "xls" || ext == "docx" || ext == "doc" || ext == 'xlsm') {
      setDemoImage(true);
    } else {
      setFilePath(fullPath);
      setDemoImage(false);
    }
  };

  const handleQuillChange = (value) => {
    setSubmissionNote(value);
  };

  const addSubmissionsChats = () => {
    const data = {
      notes: comment,
      assetId: selectedFileObject.id,
    };

    AddSubmissionsChatService(props.token, data).then((res) => {
      if (res) {
        setNoteList(res.noteList);
        setComment('');
      }
    });
  };


  // UPDATED: Use filtered documents for select all
  const handleSelectAllDocuments = () => {
    const newSelectAll = !selectAllDocuments;
    setSelectAllDocuments(newSelectAll);
    if (newSelectAll) {
      const allDocumentIds = filteredDocuments.map(doc => doc.id);
      setSelectedDocuments(allDocumentIds);
    } else {
      setSelectedDocuments([]);
    }
  };

  const handleDocumentCheckboxChange = (id) => {
    setSelectedDocuments(prev =>
      prev.includes(id) ? prev.filter(docId => docId !== id) : [...prev, id]
    );
  };

  // UPDATED: Use filtered images for select all
  const handleSelectAllImages = () => {
    const newSelectAll = !selectAllImages;
    setSelectAllImages(newSelectAll);
    if (newSelectAll) {
      const allImageIds = filteredImages.map(img => img.id);
      setSelectedImages(allImageIds);
    } else {
      setSelectedImages([]);
    }
  };

  const handleImageCheckboxChange = (id) => {
    setSelectedImages(prev =>
      prev.includes(id) ? prev.filter(imgId => imgId !== id) : [...prev, id]
    );
  };

  const handleSubmissionSuccess = (res) => {
    props.setFileList(res.fileList.fileList);
    props.setSubmissionList(res.submissionList.submissionList);
    props.setSubmissionInnerCount(res.innerCountsOfSubmission);

    const submittedAssetIds = [...selectedImages, ...selectedDocuments];

    if (props.graphicsfileList && props.graphicsfileList.length > 0) {
      const updatedGraphicsFileList = props.graphicsfileList.filter(
        (file) => !submittedAssetIds.includes(file.id)
      );
      props.setGraphicsFileList(updatedGraphicsFileList);
    }

    if (props.docFileList && props.docFileList.length > 0) {
      const updatedDocFileList = props.docFileList.filter(
        (file) => !submittedAssetIds.includes(file.id)
      );
      props.setDocFileList(updatedDocFileList);
    }

    if (props.fileList && props.fileList.length > 0) {
      const updatedFileList = props.fileList.filter(
        (file) => !submittedAssetIds.includes(file.id)
      );
      props.setFileList(updatedFileList);
    }

    if (res.fileList.asinAssetsCount) {
      if (props.selectedASIN === 'Unmapped Assets') {
        props.setUnmappedCount(res.fileList.asinAssetsCount.unmapped_count);
      } else {
        const updatedCount = res.fileList.asinAssetsCount.resultcnt[0];

        if (updatedCount) {
          props.setAsinCount((prevCounts) =>
            prevCounts.map((item) =>
              item.asinList === updatedCount.asinList ? updatedCount : item
            )
          );
        }
      }
    }

    setSelectedImages([]);
    setSelectedDocuments([]);
    setSelectAllImages(false);
    setSelectAllDocuments(false);
    setConfrimationForSubmition(false);
    setAsinList('');
    setSelectedTitles('');
    setSubmissionNote('');
  };    

  const handleDownloadImage = async (url, fileObject) => {
    try {
      setdownloading(fileObject.id);
      const response = await fetch(url, {
        method: 'GET',
        referrerPolicy: 'no-referrer',
        cache: 'no-store',
      });

      if (!response.ok) throw new Error(`Network response was not ok for ${fileObject.id}`);

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download = fileObject.actualFileName || 'downloaded_file';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      URL.revokeObjectURL(blobUrl);
      setdownloading(false);
    } catch (error) {
      console.error('Failed to download files:', error);
      setdownloading(false);
    }
  };

  const columns = [
    {
      width: 50,
      accessor: "checkbox",
      Cell: (rowInfo) => (
        <input
          type="checkbox"
          value={rowInfo.original.id}
          checked={selectedDocuments.includes(rowInfo.original.id)}
          onChange={() => handleDocumentCheckboxChange(rowInfo.original.id)}
        />
      ),
    },
    {
      Header: "Name",
      accessor: "actualFileName",
      Cell: ({ value }) => (
        <p title={value} className="m-0 comment-paragraph">{value}</p>
      ),
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: (rowInfo) => {
        const file = rowInfo.original;
        const fileExtension = file.actualFileName.split('.').pop().toLowerCase();
        const isPDF = fileExtension === 'pdf';

        return (
          <div className="d-flex justify-content-center align-items-center">
            <button
              onClick={() => submissionsChats(rowInfo.original)}
              className="btn"
            >
              <img
                className="comments-bg-color"
                height={20}
                width={20}
                title="Notes"
                src={CommentIcon}
              />
            </button>
            {isPDF && (
              <img
                src={ViewIcon}
                alt="Preview"
                height={20}
                width={20}
                style={{ cursor: 'pointer' }}
                title="Preview"
                onClick={() => {
                  setFilePath(file.filePath);
                  setSelectedFileObject(file);
                  setIsAttachmentOpen(true);
                }}
              />
            )}
            <img
              src={DownloadIcon}
              alt="Download"
              height={20}
              width={20}
              style={{ cursor: 'pointer', marginLeft: isPDF ? '10px' : '0px' }}
              title="Download"
              className={
                downloading && downloading === file.id
                  ? "button-img-background-download-inprogress"
                  : ""
              }
              onClick={() => {
                if (downloading !== file.id) {
                  setSelectedFileObject(file);
                  setdownloading(file.id);
                  handleDownloadImage(file.filePath, file);
                }
              }}
            />
          </div>
        );
      }
    }
  ];

  return (
    <>
      <Card className="card-of-problemarea p-3 ml-3 mt-1">
        <Col md={12} className="d-flex justify-content-between align-items-center mr-5">
          <div style={{ maxHeight: '105px', overflowY: 'auto', minWidth: '150px' }}>
            {asinList && asinList ? (
              <div className='d-flex'>
                <h6><b>{asinList} : </b> &nbsp;</h6>
                <h6 className="comment-paragraph-Project-asin-title" title={selectedTitles}> {selectedTitles}</h6>
              </div>
            ) : ''}
          </div>
        </Col>
        <Row>
          <Col md={6}>
            <Card className="card-of-problemarea p-3 mt-1">
              <div className="d-flex align-items-center justify-content-between">
                <h5 className="mb-0 mr-3">
                  <b>Documents List</b>
                  <small className="text-muted ml-2">({searchedDocuments.length})</small>
                </h5>
                  <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    id="selectAllDocs"
                    checked={selectAllDocuments}
                    onChange={handleSelectAllDocuments}
                  />
                  <label htmlFor="selectAllDocs" className="mb-0 ml-2">
                    <b>Select All</b>
                  </label>
                </div>
                <Input
                  type="text"
                  placeholder="Search"
                  className="w-25"
                  value={documentSearchText}
                  onChange={(e) => setDocumentSearchText(e.target.value)}
                />
              </div>
              <ReactTable
                className="-fixed -highlight -striped mt-2"
                data={searchedDocuments}
                columns={columns}
                defaultPageSize={4}
                noDataText="No documents found..."
                getTheadProps={() => ({
                  style: {
                    overflow: "hidden",
                    background: "#B1FA63",
                    color: "#243837",
                  },
                })}
                getTrProps={() => ({
                  style: {
                    height: "37px",
                  },
                })}
              />
            </Card>
          </Col>
          <Col md={6}>
            <Card className="card-of-problemarea p-3 all-tab-fixed-images-card-height">
              <div className="d-flex align-items-center justify-content-between">
                <h5 className="mb-0 mr-3">
                  <b>Images</b>
                  <small className="text-muted ml-2">({searchedImages.length})</small>
                </h5>
                <div className="d-flex align-items-center w-75 justify-content-end">
                  <div className="d-flex align-items-center mr-3">
                    <input
                      type="checkbox"
                      id="selectAll"
                      checked={selectAllImages}
                      onChange={handleSelectAllImages}
                    />
                    <label htmlFor="selectAll" className="mb-0 ml-2">
                      <b>Select All</b>
                    </label>
                  </div>
                  <Input
                    type="text"
                    placeholder="Search"
                    className="w-50"
                    value={imageSearchText}
                    onChange={(e) => setImageSearchText(e.target.value)}
                  />
                </div>
              </div>
              <Row className="image-scroll-container mt-3">
                {searchedImages && searchedImages.length > 0 ? (
                  searchedImages.map((img, index) => (
                    <Col md={4} key={index}>
                      <Card className="p-2 text-center submissions-image-wrapper position-relative">
                        <button
                          onClick={() => submissionsChats(img)}
                          className="btn p-0 images-note-icon"
                        >
                          <img
                            src={CommentIcon}
                            alt="Comment"
                            height={16}
                            width={16}
                            title="Notes"
                          />
                        </button>
                        <img
                          src={img.filePath}
                          alt={img.actualFileName}
                          className="submissions-image-box"
                        />
                        <input
                          type="checkbox"
                          className="form-check-input submissions-checkbox"
                          checked={selectedImages.includes(img.id)}
                          onChange={() => handleImageCheckboxChange(img.id)}
                        />
                       <div className="d-flex justify-content-between align-items-center">
                        <small>
                          <b>
                            {img.id}{img.revision ? ` · V${img.revision}` : ''}
                          </b>
                        </small>

                        {/* Image Locator */}
                        <small>
                          <b style={{ fontSize: '10px' }}>
                            {img.imageLocator || ''}
                          </b>
                        </small>

                        <small>
                          <b style={{ color: '#B01A00' }}>
                            #{img.amazonPosition || ''}
                          </b>
                        </small>
                      </div>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <Col md={12} className="text-center text-muted mt-5">
                    <p>No images available.</p>
                  </Col>
                )}
              </Row>
            </Card>
          </Col>
        </Row>
        <Col md={12} className="mt-3">
          <label><h6><b>Note:</b></h6></label>
          <ReactQuill
            theme={'snow'}
            value={sumbmissionNote}
            modules={Editor.modules}
            formats={Editor.formats}
            onChange={handleQuillChange}
            bounds={'.quill-prod'}
            placeholder='Add your comments here'
          />
        </Col>

        <Col md={12} className="mt-4 mb-2">
          <div className="d-flex justify-content-center">
            <Button
              className="btn-background-color mr-5"
              style={{ width: '300px' }}
              onClick={() => setConfrimationForSubmition(true)}
              // disabled={!asinList || (selectedImages.length === 0 && selectedDocuments.length === 0)}
              disabled={selectedDocuments.length === 0 && selectedImages.length===0}
           >
              Send for Approval
            </Button>
          </div>
        </Col>
      </Card>
      <CustomModal
        header={<> Attachment
          <FontAwesomeIcon
            className={`ml-3 ${downloading ? 'button-img-background-download-inprogress' : ''}`}
            style={{ cursor: 'pointer' }}
            icon={faDownload}
            onClick={() => handleDownloadImage(filePath, selectedFileObject)}
          />
        </>}
        isOpen={isAttachmentOpen}
        toggle={() => { setIsAttachmentOpen(!isAttachmentOpen); setdownloading(false) }}
        size={"lg"}
        className='curve-popup'
        footer={
          <>
            <Button
              color={"link"}
              onClick={() => setIsAttachmentOpen(!isAttachmentOpen)}
            >
              Cancel
            </Button>
          </>
        }
      >
        <Label>
          <div>
            <iframe
              src={filePath}
              title="File Display"
              width="100%"
              height="500"
            ></iframe>
          </div>
        </Label>
      </CustomModal>
      <CustomModal
        isOpen={isCommentsPopUpOPen}
        toggle={() => setIsCommentsPopUpOPen(false)}
        size="xl"
        header={<p title={selectedFileObject.actualFileName} className="comment-paragraph-Project-asin-title">{selectedFileObject.actualFileName}</p>}
        className="curve-popup "
      >
        <LoadingOverlay
          active={loadScreen}
          styles={{
            overlay: (base) => ({
              ...base,
              background: '#f1f4f6',
              opacity: 1,
            }),
            content: (base) => ({
              ...base,
              color: '#000',
            }),
          }}
          spinner={<Loader active type="ball-pulse" />}
          text="Loading chat details..."
        >
          <AssetsCommentsPopup
            filePath={filePath}
            demoImage={demoImage}
            noteList={noteList}
            setNote={setComment}
            note={comment}
            action={false}
            selectedFileObject={selectedFileObject}
            addCMAssetChats={addSubmissionsChats}
          />
        </LoadingOverlay>
      </CustomModal>
     
      <SendAssetsApprovalPopup
        isOpen={confrimationForSubmition}
        toggle={() => setConfrimationForSubmition(false)}
        mode="all"
        selectedDocumentIds={selectedDocuments}
        selectedImageIds={selectedImages}
        documentList={filteredDocuments}
        imageList={filteredImages}
        filterSubcategoryList={props.filterSubcategoryList}
        filterProductSubcategoryList={props.filterProductSubcategoryList}
        selectedProjectData={props.selectedProjectData}
        selectedSubCategories={props.selectedSubCategories}
        selectedASIN={props.selectedASIN}
        submissionNote={sumbmissionNote}
        submissionName={
          props.selectedASIN
            ? `Assets_${props.selectedASIN}`
            : `${props.selectedProjectData.projectId}_Assets_`
        }
        headerTitle="Send Assets for Approval"
        token={props.token}
        onSubmitSuccess={handleSubmissionSuccess}
        imageLocatorList={props.imageLocatorList}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,

});
export default connect(mapStateToProps)(AllSubmission);
